(() => {
  const owner = document.currentScript;
  const sliderUrl = owner.dataset.sliderUrl;
  const quickviewUrl = owner.dataset.quickviewUrl;
  const load = (src) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
  const start = () => {
    if (!document.querySelector('.quick-view')) return;
    load(sliderUrl).then(() => load(quickviewUrl)).catch(() => {
      console.warn('The legacy quick view could not load. Product links remain available.');
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
